import apiClient from '../../api/apiClient';

const BASE = '/api/v1/admin/news';

const unwrap = (response) => response.data?.data ?? response.data;

const newsService = {
  listNews: async (params = {}) => {
    const response = await apiClient.get(BASE, { params });
    return unwrap(response);
  },

  getNews: async (id) => {
    const response = await apiClient.get(`${BASE}/${id}`);
    return unwrap(response);
  },

  runIngestion: async () => {
    const response = await apiClient.post(
      `${BASE}/run-ingestion`,
      {},
      { timeout: 600000 },
    );
    return unwrap(response);
  },

  updateNews: async (id, payload) => {
    const response = await apiClient.patch(`${BASE}/${id}`, payload);
    return unwrap(response);
  },

  syncLogo: async (id) => {
    const response = await apiClient.post(`${BASE}/${id}/sync-logo`);
    return unwrap(response);
  },

  publishNews: async (id, payload = {}) => {
    const response = await apiClient.post(`${BASE}/${id}/publish`, payload);
    return unwrap(response);
  },

  unpublishNews: async (id) => {
    const response = await apiClient.post(`${BASE}/${id}/unpublish`);
    return unwrap(response);
  },

  rejectNews: async (id) => {
    const response = await apiClient.post(`${BASE}/${id}/reject`);
    return unwrap(response);
  },
};

export default newsService;
